//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Global from '../../../Services/Common/Global';
import Commons from '../../../Services/Common/Common';
import M_MET_BASIC_01 from './M_MET_BASIC_01';
import { Loading } from '../../../Components/MUIs';
import { useDispatch, useSelector } from 'react-redux';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import {
  useSearch1,
  useSearch2,
  useSearch3,
  useSearch4,
  useSave1,
  useSave2,
  useSave3,
  useSave4,
  useSave5,
} from './M_MET_BASIC_01_Query';
import useFcmHandler from '../../../Hooks/useFcmHandler';
import { useBackStack } from '../../../Hooks/back/useBackStack';
import { BackInfoActions } from '../../../Reducer/BackInfoReducer';
//#endregion

function M_MET_BASIC_01Function() {
  //#region 변수
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const bottomSheetState = useSelector((state) => state.bottomSheet);

  /** 서명하기 버튼 등에서 사용 - Redux bottomSheet 열기/닫기 */
  const ToggleDrawer = (anchor, open) => (e) => {
    dispatch(
      BottomSheetActions.SetBottomSheetState({
        bottom: !!open,
        type: open ? anchor || 'signature' : bottomSheetState?.type || '',
      })
    );
  };
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [participantTab, setParticipantTab] = useState(0); // 참석자 탭
  const [alarmData, setAlarmData] = useState([]);
  const [signInputs, setSignInputs] = useState({
    mapUrl: '',
    mapFiles: {},
  }); // 서명 state
  const [modalToggle1, setModalToggle1] = useState(false); // 참석 여부 다이얼로그 (도급 아닌경우만 사용)
  const [showNonAttendReason, setShowNonAttendReason] = useState(false);
  const [nonAttendReason, setNonAttendReason] = useState('');

  const signatureCanvas = useRef(); // 서명 REF
  const imgRef = useRef(); // 진행사진 REF
  //#endregion

  const { runAsync: Search1Async } = useSearch1();
  const { runAsync: Search2Async } = useSearch2();
  const { runAsync: Search3Async } = useSearch3();
  const { runAsync: Search4Async } = useSearch4();
  const sendFcm = useFcmHandler();
  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();
  const { runAsync: Save3Async } = useSave3();
  const { runAsync: Save4Async } = useSave4();
  const { runAsync: Save5Async } = useSave5();

  // 스택형 뒤로가기: 참석 여부 다이얼로그(도급 아닌경우) 열린 경우
  useBackStack({
    type: 'dialog',
    enabled: modalToggle1,
    onBack: () => {
      dispatch(
        BottomSheetActions.SetBottomSheetState({
          bottom: false,
          type: '',
        })
      );
    },
  });

  useEffect(() => {
    Init();

    return () => {
      dispatch(
        BottomSheetActions.SetBottomSheetState({
          bottom: false,
          type: '',
        })
      );
    };
  }, []);

  const Init = async () => {
    setLoading(true);
    try {
      dispatch(NavBarInfoActions.setType('titleBar'));
      dispatch(
        NavBarInfoActions.setTitleName(
          id?.indexOf('C') === 0 ? '도급사업 안전보건 협의체 회의' : '회의록'
        )
      );
      dispatch(NavBarInfoActions.setBgColor('#FFF'));

      const result = await SearchLogic1(id, userInfo);
      await CheckAttendanceStatus(result, userInfo);
    } catch (e) {
      console.log('Error: ', e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };

  //#region 조회

  /** 상세 응답 처리: 승인/서명 안내, 진행사진, 참석자 서명 이미지 base64 */
  const processDetailData = async (data, _userInfo, isRep) => {
    if (!data || !Array.isArray(data) || data.length === 0) return data;
    if (data[0].type === 'Ok') {
      dispatch(
        showSnackbar({
          message: '승인완료한 회의록입니다.',
          type: 'warning',
        })
      );
    }
    if (data[0].proceedingsImage) GetPhoto(data[0].proceedingsImage);
    if (!isRep) {
      const ownData = data.find(
        (f) => f.id === Commons.DecryptoAES(_userInfo?.userid)
      );
      if (ownData?.type === 'Ok') {
        dispatch(
          showSnackbar({
            message: '서명완료한 회의록입니다.',
            type: 'warning',
          })
        );
        if (ownData.filePath) {
          const imageUrl = Global.file.useUrl + 'files/' + ownData.filePath;
          const response = await fetch(imageUrl, { mode: 'cors' });
          if (!response.ok) return;
          const blob = await response.blob();
          const reader = new FileReader();
          reader.onloadend = () => {
            setSignInputs({ mapUrl: reader.result, mapFiles: {} });
          };
          reader.readAsDataURL(blob);
        }
      }
    }
    setAlarmData(data);
    return data;
  };

  /** 회의록 상세 조회 (Global.urls.Meeting GetMetBasic01R1~R3) */
  const SearchLogic1 = async (_value1, _value2) => {
    setAlarmData([]);
    setSignInputs({ mapUrl: '', mapFiles: {} });
    const chaebun = (id || _value1 || '').toString().substring(1);
    const isC = (id || _value1 || '').toString().indexOf('C') === 0;
    const isRep = _value2?.coId === Commons.DecryptoAES(_value2?.userid);

    try {
      let data = [];
      if (isRep) {
        data = await Search1Async({ chaebun, userInfo: _value2 });
      } else if (isC) {
        data = await Search2Async({ chaebun, userInfo: _value2 });
      } else {
        data = await Search3Async({ chaebun, userInfo: _value2 });
      }
      return await processDetailData(
        Array.isArray(data) ? data : [data],
        _value2,
        isRep
      );
    } catch (e) {
      console.log(e);
      return [];
    }
  };
  //#endregion
  //#region 저장

  /** 서명 완료: 대표 승인 또는 참석자 서명 (Global.urls.Meeting SaveMetBasic01U1~U3) */
  const SaveLogic1 = async () => {
    const chaebun =
      alarmData[0]?.chaebun ?? alarmData[0]?.chaebun ?? id?.substring(1) ?? '';
    const isC = (id || '').toString().indexOf('C') === 0;
    const isRep = userInfo.coId === Commons.DecryptoAES(userInfo.userid);

    try {
      // 대표자 서명
      if (isRep) {
        const res = await Save1Async({ row: { chaebun }, userInfo });
        if (res?.[0]?.type === 'Error') {
          dispatch(showSnackbar({ message: res[0].message, type: 'error' }));
          return;
        }
        dispatch(showSnackbar({ message: '승인되었습니다.', type: 'success' }));

        dispatch(BackInfoActions.pop());
        dispatch(BackInfoActions.pop());
        navigate('/M_AlarmList');
        return;
      }

      // 참석자 서명
      const hasFile =
        signInputs.mapFiles &&
        (signInputs.mapFiles.size > 0 || signInputs.mapFiles.name);
      if (!hasFile) {
        dispatch(
          showSnackbar({ message: '서명을 진행하세요.', type: 'warning' })
        );
        return;
      }

      const savedFilePath = await SaveLogic2(signInputs.mapFiles);
      const custCd = alarmData[0]?.custCd ?? alarmData[0]?.custCd ?? '';
      const fileName = signInputs.mapFiles.name || '';
      const filePath = isC
        ? `Business/${custCd}/SUB_BASIC_03/${fileName}`
        : `Business/${custCd}/SAC_BASIC/${fileName}`;

      const payload = {
        chaebun,
        checkYn: 'Y',
        fileName,
        filePath: savedFilePath ? filePath : '',
        userInfo,
      };

      const res = isC
        ? await Save2Async({ row: payload, userInfo })
        : await Save3Async({ row: payload, userInfo });

      if (res?.[0]?.type === 'Error') {
        dispatch(showSnackbar({ message: res[0].message, type: 'error' }));
        return;
      }
      dispatch(
        showSnackbar({ message: '서명이 완료되었습니다.', type: 'success' })
      );

      dispatch(BackInfoActions.pop());
      dispatch(BackInfoActions.pop());
      navigate('/M_AlarmList');
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: e.code === 'CUSTOM_ERROR' ? e.type : 'error',
        })
      );
    }
  };

  // 서명 파일 저장
  const SaveLogic2 = async (_file) => {
    setLoading(true);

    let filePath = '';
    let finalSavePath = '';

    if (id.indexOf('C') === 0) {
      // 안전보건 협의체(C)
      filePath = `Business/${alarmData[0].custCd}/SUB_BASIC_03`;
    } else {
      //산업안전 회의록(I)
      filePath = `Business/${alarmData[0].custCd}/SAC_BASIC`;
    }

    try {
      let formList = new FormData();
      formList.append('UserId', userInfo.userid);
      formList.append('FilePath', filePath);
      formList.append('FormFile', _file);

      const result = await Commons.Axios(
        'file2',
        Global.file.useUrl + Global.urls.Execute.videoUpload,
        null,
        formList
      );

      finalSavePath = result?.data?.filePath || '';

      if (finalSavePath) {
        const savePath = finalSavePath
          .replace(/^.*\\PreviewFiles/, 'PreviewFiles')
          .replace(/\\/g, '/');

        return savePath;
      } else {
        dispatch(
          showSnackbar({
            message: '파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      }
    } catch (e) {
      console.error('SaveLogic2 Error:', e);
      return null;
    } finally {
      setLoading(false);
    }
  };

  /** 회의 참석 여부 업데이트 (도급 C: SaveMetBasic01U4 / 산업안전 I: SaveMetBasic01U5) — UI는 도급 아닌경우만 */
  const SaveLogic3 = async (_attendYn) => {
    const chaebun = (id || '').toString().substring(1);
    const isC = (id || '').toString().indexOf('C') === 0;
    const payload = {
      chaebun,
      attendYn: _attendYn,
      nonAttendReason: _attendYn === 'N' ? nonAttendReason : '',
      userInfo,
    };
    try {
      const res = isC
        ? await Save4Async({ row: payload, userInfo })
        : await Save5Async({ row: payload, userInfo });
      if (res?.[0]?.type === 'Error') {
        dispatch(showSnackbar({ message: res[0].message, type: 'error' }));
        return;
      }
      dispatch(
        showSnackbar({
          message:
            _attendYn === 'Y' ? '참석 처리되었습니다.' : '불참 처리되었습니다.',
          type: 'success',
        })
      );
      setModalToggle1(false);
      setShowNonAttendReason(false);
      setNonAttendReason('');
      if (_attendYn === 'N') await ReturnRequest();
      await SearchLogic1(id, userInfo);
    } catch (e) {
      console.error('Attendance Error:', e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  /** 불참 시 알림 대상 조회(Search4) 후 FCM 발송 */
  const ReturnRequest = async () => {
    const updateId = alarmData[0]?.UPDATE_ID ?? alarmData[0]?.updateId ?? '';
    if (!updateId) return;
    try {
      const res = await Search4Async({ updateId });
      const list = res?.data ?? (Array.isArray(res) ? res : []);
      const first = Array.isArray(list) ? list[0] : list;
      const targetUserId = first?.userId ?? first?.USER_ID ?? first?.userid;
      if (!targetUserId) return;
      await sendFcm({
        targetUserId,
        title: '안전보건협의체 회의록',
        body: `${userInfo.userNm}님이 참석하지 않았습니다.`,
        codeGroup: 'AL_001_004',
        route: '',
        responseData: '',
      });
    } catch (e) {
      console.error('ReturnRequest Error:', e);
    }
  };

  // 사진 가져오기
  const GetPhoto = async (_filePath) => {
    imgRef.current = null;
    try {
      imgRef.current = Global.file.useUrl + 'files/' + _filePath;
    } catch (e) {
      console.log(e);
    } finally {
    }
  };

  /** 도급사업(C)은 참석 컬럼 없음 → 자동 참석 팝업 없음 */
  const CheckAttendanceStatus = (data, _userInfo) => {
    if ((id || '').toString().indexOf('C') === 0) {
      return;
    }
    const currentUser = data.find(
      (f) => f.id === Commons.DecryptoAES(_userInfo.userid)
    );
    if (data[0]?.state === '0' && currentUser && currentUser.attendYn !== 'Y') {
      setModalToggle1(true);
    }
  };

  const HandleNonAttendClick = () => {
    setShowNonAttendReason(true);
  };

  // 참석일자 포맷
  const FormatDate = (_date, _startTime, _endTime) => {
    // 날짜가 없으면 기본값 반환
    if (!_date) {
      return { formattedDate: '', formattedTime: '' };
    }

    // 날짜 파싱 (YYYY-MM-DD 형식)
    const dateParts = _date.split('-');
    const year = dateParts[0];
    const month = parseInt(dateParts[1]);
    const day = parseInt(dateParts[2]);

    // 요일 배열
    const days = ['일', '월', '화', '수', '목', '금', '토'];

    // Date 객체 생성하여 요일 계산
    const date = new Date(year, month - 1, day);
    const dayOfWeek = days[date.getDay()];

    // 날짜 포맷팅
    const formattedDate = `${year}년 ${month}월 ${day}일 ${dayOfWeek}`;

    // 시간 포맷팅 (HH:MM 형식)
    let formattedTime = '';
    if (_startTime && _endTime) {
      const startTimeParts = _startTime.split(':');
      const endTimeParts = _endTime.split(':');
      const startHour = parseInt(startTimeParts[0]);
      const startMinute = parseInt(startTimeParts[1]);
      const endHour = parseInt(endTimeParts[0]);
      const endMinute = parseInt(endTimeParts[1]);

      formattedTime = `${startHour}시 ${startMinute
        .toString()
        .padStart(2, '0')}분 ~ ${endHour}시 ${endMinute
        .toString()
        .padStart(2, '0')}분`;
    }

    return { formattedDate, formattedTime };
  };

  // 참석자 파싱
  const ParseParticipant = (_alarmData) => {
    // ID가 있는 경우 ID로, 없는 경우 NAME으로 기준해서 중복 제거
    const uniqueNames = _alarmData.reduce((acc, item) => {
      if (item.id) {
        if (!acc.some((existingItem) => existingItem.id === item.id)) {
          acc.push(item);
        }
      } else {
        if (!acc.some((existingItem) => existingItem.name === item.name)) {
          acc.push(item);
        }
      }
      return acc;
    }, []);

    // 참석자 수에 따라 문자열을 조정
    const namesCount = uniqueNames.length;
    let names;

    if (namesCount > 5) {
      const displayedNames = uniqueNames
        .slice(0, 5)
        .map((item) => item.name)
        .join(', ');
      const remainingCount = namesCount - 5;
      names = `${displayedNames} 외 ${remainingCount}명`;
    } else {
      names = uniqueNames.map((item) => item.name).join(', ');
    }

    return names;
  };

  // 회의 안건, 회의 내용 파싱
  const ParseMeeting = (_alarmData) => {
    return [
      ...new Map(
        _alarmData.map((item) => [
          `${item.agendaName}|${item.resultDiscussion}`,
          {
            agendaName: item.agendaName,
            resultDiscussion: item.resultDiscussion,
          },
        ])
      ).values(),
    ];
  };

  // 참석자 구분 로직
  const GetAttendees = (gubun) => {
    return id?.indexOf('C') === 0
      ? alarmData.filter((f) => f.gubun === gubun)
      : alarmData.filter((f) => f.gubun === gubun && f.attendYn === 'Y');
  };

  // 미참석자 구분 로직
  const GetNonAttendees = (gubun) => {
    return alarmData.filter((f) => f.gubun === gubun && f.attendYn !== 'Y');
  };

  /** API 응답을 참석자/상세 배열로 정규화 */
  const normalizeDetailResponse = (raw) => {
    if (Array.isArray(raw)) return raw;
    const list = raw?.data ?? raw?.Data ?? [];
    return Array.isArray(list) ? list : list ? [list] : [];
  };

  /** 서명 조회: getMetBasic01R2(C) / getMetBasic01R3(I) 호출 후 FilePath로 이미지 로드 */
  const LoadExistingSignatureIfNeeded = async () => {
    if (!userInfo?.userid || !id) {
      return;
    }
    const chaebun = (id || '').toString().substring(1);
    const isC = (id || '').toString().indexOf('C') === 0;
    const decryptedUserId = Commons.DecryptoAES(userInfo.userid);
    try {
      const raw = isC
        ? await Search2Async({ chaebun, userInfo })
        : await Search3Async({ chaebun, userInfo });
      const list = normalizeDetailResponse(raw);
      const own = list.find((f) => {
        const rowId = f.ID ?? f.id;
        return rowId === decryptedUserId || rowId === userInfo.userid;
      });
      if (!own) {
        return;
      }
      let filePath = own.FILE_PATH ?? own.filePath ?? own.FilePath;
      if (!filePath && (own.fileName || own.FILE_NAME)) {
        const custId =
          own.custID ??
          own.CUST_CD ??
          own.custCd ??
          list[0]?.CUST_CD ??
          list[0]?.custCd ??
          list[0]?.custID;
        const fileName = own.fileName ?? own.FILE_NAME;
        if (custId) {
          filePath = `Business/${custId}/${isC ? 'SUB_BASIC_03' : 'SAC_BASIC'}/${fileName}`;
        }
      }
      if (!filePath) {
        return;
      }
      const imageUrl = Global.file.useUrl + 'files/' + filePath;
      const response = await fetch(imageUrl, { mode: 'cors' });
      if (!response.ok) return;
      const blob = await response.blob();
      const reader = new FileReader();
      reader.onloadend = () => {
        setSignInputs({ mapUrl: reader.result, mapFiles: {} });
      };
      reader.readAsDataURL(blob);
    } catch (e) {}
  };

  /** 서명하기 클릭: 서명 조회 후 바텀시트 오픈 */
  const HandleOpenSignatureDrawer = async () => {
    await LoadExistingSignatureIfNeeded();
    ToggleDrawer('signature', true)();
  };
  //#endregion

  return (
    <div className="wrap">
      <M_MET_BASIC_01
        id={id}
        userInfo={userInfo}
        lanInfo={lanInfo}
        participantTab={participantTab}
        setParticipantTab={setParticipantTab}
        alarmData={alarmData}
        bottomSheetState={bottomSheetState}
        signatureCanvas={signatureCanvas}
        imgRef={imgRef}
        signInputs={signInputs}
        setSignInputs={setSignInputs}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        HandleNonAttendClick={HandleNonAttendClick}
        showNonAttendReason={showNonAttendReason}
        setShowNonAttendReason={setShowNonAttendReason}
        nonAttendReason={nonAttendReason}
        setNonAttendReason={setNonAttendReason}
        // 함수
        SaveLogic1={SaveLogic1}
        SaveLogic3={SaveLogic3}
        ReturnRequest={ReturnRequest}
        ToggleDrawer={ToggleDrawer}
        onOpenSignatureDrawer={HandleOpenSignatureDrawer}
        FormatDate={FormatDate}
        ParseParticipant={ParseParticipant}
        ParseMeeting={ParseMeeting}
        GetAttendees={GetAttendees}
        GetNonAttendees={GetNonAttendees}
      />
      <Loading open={loading} />
    </div>
  );
}

export default M_MET_BASIC_01Function;
